import { Link } from 'react-router-dom'
import { ChevronRight, BookOpen } from 'lucide-react'
import sidebarData from '@/docs/_sidebar.json'
import type { DocsNavigation } from '@/types/docs'

interface DocsBreadcrumbProps {
  currentPath: string
  basePath: string
}

/**
 * Breadcrumb navigation showing current location in documentation
 */
export function DocsBreadcrumb({ currentPath, basePath }: DocsBreadcrumbProps) {
  const navigation = sidebarData as DocsNavigation

  // Find the section and item for the current path
  let sectionTitle = ''
  let pageTitle = ''

  for (const section of navigation.sections) {
    const item = section.items.find((i) => i.path === currentPath)
    if (item) {
      sectionTitle = section.title
      pageTitle = item.title
      break
    }
  }

  // If not found, extract from path
  if (!sectionTitle && currentPath) {
    const parts = currentPath.split('/')
    sectionTitle = parts[0]?.replace(/-/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase()) || ''
    pageTitle = parts[1]?.replace(/-/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase()) || ''
  }

  return (
    <nav aria-label="Breadcrumb" className="mb-6">
      <ol className="flex items-center gap-1 text-sm text-muted-foreground">
        <li>
          <Link
            to={basePath}
            className="flex items-center gap-1 hover:text-foreground transition-colors"
          >
            <BookOpen className="h-4 w-4" />
            <span>Help</span>
          </Link>
        </li>

        {sectionTitle && (
          <>
            <li>
              <ChevronRight className="h-4 w-4" />
            </li>
            <li>
              <span className="hover:text-foreground transition-colors">
                {sectionTitle}
              </span>
            </li>
          </>
        )}

        {pageTitle && (
          <>
            <li>
              <ChevronRight className="h-4 w-4" />
            </li>
            <li>
              <span className="text-foreground font-medium">{pageTitle}</span>
            </li>
          </>
        )}
      </ol>
    </nav>
  )
}
